import Vue from "vue"
import Form from "./tracking-form/TrackingForm.vue"

/**
 * @title Tracking Form
 * @description Track your Shipment
 */

const tracking = () => {
	const trackingForm = document.querySelector("#tracking-form")
	if (trackingForm) {
		new Vue({
			el: "#tracking",
			template: "<Form/>",
			components: { Form },
		})
	}
}

export { tracking }
